import { apiGateway } from "../api";

async function enviarDocumentosSolicitacaoGuias(body) {
    try {
        const response = await apiGateway.post('/enviar-documentos/envio/processar', body);

        return response.data;

    } catch (error) {
        return error.response;
    }
}

async function getCategoria(categoria, nivelAcesso) {
    const body = { categoria, nivelAcesso }
    try {
        const response = await apiGateway.post('/enviar-documentos/categorias/consultar', body);

        return response.data.categoria;
    } catch (error) {
        return error;
    }
}

async function getSubCategoria(categoria) {
    const body = { categoria }
    try {
        const response = await apiGateway.post('/enviar-documentos/categorias/sub/consultar', body);

        return response.data.listaSubCategoria
    } catch (error) {
        return error;
    }
}

export { enviarDocumentosSolicitacaoGuias, getCategoria, getSubCategoria };